import axios from "axios";
import { apiConfig } from "../../config/api";
import secureStorage from "../../utils/secureStorage";
const API_BASE_URL = apiConfig.basePath;
// Fetch group members from get-my-link API
export const getMyLink = async (groupId) => {
  try {
    const token = secureStorage.getItem("accessToken");
    if (!token) {
      throw new Error("No access token found");
    }
    const response = await axios.post(
      `${API_BASE_URL}get-my-link`,
      { group_id: groupId },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

// Fetch groups from my-group API
export const getGroups = async () => {
  try {
    const token = secureStorage.getItem("accessToken");
    if (!token) {
      throw new Error("No access token found");
    }
    const response = await axios.get(`${API_BASE_URL}my-group`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const userList = async (page = 1, search = "") => {
  try {
    const token = secureStorage.getItem("accessToken");
    if (!token) {
      throw new Error("No access token found");
    }

    const formData = new FormData();
    formData.append("page", page);
    if (typeof search === "string" && search.trim().length > 0) {
      formData.append("search", search.trim());
    }

    const response = await axios.post(`${API_BASE_URL}search-user`, formData, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    const resData = response.data?.data;

    return {
      users: resData?.data || [],
      currentPage: resData?.current_page || page,
      lastPage: resData?.last_page || 1,
      total: resData?.total || 0,
    };
  } catch (error) {
    throw error;
  }
};

export const createMyLink = async (data) => {
  try {
    const token = secureStorage.getItem("accessToken");
    if (!token) {
      throw new Error("No access token found");
    }
    const formData = new FormData();
    formData.append("name", data.name);
    formData.append("members", JSON.stringify(data.users));
    const response = await axios.post(
      `${API_BASE_URL}create-my-link`,
      formData,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

// Delete a link by ID
export const deleteLink = async (id) => {
  try {
    const token = secureStorage.getItem("accessToken");
    if (!token) {
      throw new Error("No access token found");
    }
    const response = await axios.post(
      `${API_BASE_URL}delete-my-link`,
      { id },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    if (error.response) {
      throw new Error(error.response.data?.message || "Failed to delete link");
    } else if (error.request) {
      throw new Error("No response from server");
    } else {
      throw new Error("Error: " + error.message);
    }
  }
};

// Edit a link by ID
export const editLinks = async ({ id, name, members }) => {
  try {
    const token = secureStorage.getItem("accessToken");
    if (!token) {
      throw new Error("No access token found");
    }
    const response = await axios.post(
      `${API_BASE_URL}edit-my-link`,
      { id, name, members },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    if (error.response) {
      throw new Error(error.response.data?.message || "Failed to edit link");
    } else if (error.request) {
      throw new Error("No response from server");
    } else {
      throw new Error("Error: " + error.message);
    }
  }
};
